import axios from 'axios';
import { useEffect, useState } from 'react';
import OutfitBoardCard from '../cards/OutfitBoardCard';
import '../styles/outfitBoards.css';

const OutfitBoards = ({ customerId }) => {
  const [outfits, setOutfits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOutfits = async () => {
      try {
        if (!customerId) return;

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/clients/${customerId}/outfits`
        );

        if (!response.data.success || response.data.error) {
          setError(response.data.message || 'Failed to fetch outfits');
          setLoading(false);
          return;
        }
        setOutfits(response.data.data);
      } catch (err) {
        setError(err.message || 'Failed to fetch outfits');
      } finally {
        setLoading(false);
      }
    };

    fetchOutfits();
  }, [customerId]);

  if (!customerId) {
    return (
      <div className="outfitBoards">
        <div className="outfit-boards-error">
          <div className="error-content">
            <h3>Customer ID is required</h3>
            <p>Please provide a valid customer ID</p>
          </div>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="outfitBoards">
        <div className="outfit-boards-loading">
          <div className="loading-spinner"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="outfitBoards">
        <div className="outfit-boards-error">
          <div className="error-content">
            <h3>Something went wrong</h3>
            <p>{error}</p>
            <button className="retry-button" onClick={() => window.location.reload()}>
              Try Again
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="outfitBoards">
      {outfits.length === 0 ? (
        <div className="outfit-boards-empty">
          <h3>No outfits boards available</h3>
        </div>
      ) : (
        <div className="outfit-boards-grid">
          {outfits.map(outfit => (
            <OutfitBoardCard key={outfit.id} outfit={outfit} />
          ))}
        </div>
      )}
    </div>
  );
};

export default OutfitBoards;
